import React from 'react';
import { Field } from 'react-final-form';
import Select from '../Select';

const SelectField = React.forwardRef(
  (
    {
      title,
      name,
      validate,
      type,
      options,
      isMulti = true,
      onChange,
      onBlur,
      showInitialErrorWithoutTouch = false,
      // Field still validates and reports meta.error as usual - this only suppresses Select's own
      // built-in error styling/message, for a caller that renders the error itself elsewhere (e.g.
      // AvailabilityWindow, where the built-in absolutely-positioned message lands in an awkward
      // spot next to a sibling label).
      hideError = false,
      placeholder,
      hidePlaceholderOnSelect = false,
      ...restProps
    },
    ref
  ) => {
    return (
      <Field
        name={name}
        validate={validate}
        type={type}
        render={({ input, meta }) => {
          const placeholderValue =
            hidePlaceholderOnSelect && isMulti ? (input.value?.length > 0 ? '' : placeholder) : placeholder;

          return (
            <Select
              ref={ref}
              {...input}
              value={input.value}
              onChange={(value) => {
                if (onChange) {
                  onChange(value, input);
                } else {
                  input.onChange(value);
                }
              }}
              onBlur={onBlur}
              title={title}
              isMulti={isMulti}
              options={options}
              error={!hideError && (meta.touched || showInitialErrorWithoutTouch) && meta.error}
              placeholder={placeholderValue}
              {...restProps}
            />
          );
        }}
      />
    );
  }
);

export default SelectField;
